'use client';

import { VARIANT } from '@/constants';
import {
  WChanceIsSessionCard as CommonWChanceIsSessionCard,
  formatDateCommon,
  type WChanceIsSessionCardProps,
} from '@monorepo/common';
import { Format } from '@/lib/dateFns';
import React from 'react';

function WChanceIsSessionCard(props: Omit<WChanceIsSessionCardProps, 'formatDateCommon' | 'Format' | 'variant'>) {
  return (
    <CommonWChanceIsSessionCard {...props} variant={VARIANT} formatDateCommon={formatDateCommon} Format={Format} />
  );
}

export default WChanceIsSessionCard;
